import { Icon } from '@/components/icons/svg-icons';
import { profilePanelService } from '@/services/profile-panel.service';
import { useAccountInfo } from '@/hooks/query/account';
import { useGetSiteConfigs } from '@/hooks/query/use-site-configs';
import { useState, useEffect } from 'react';
import { useObservableState } from '@nf/utils-common/hooks';
import { useAccountBalance } from '@/hooks/query';
import { useSiteStore } from '@/store/site';
import { uiService } from '@/services/ui.service';
import dynamic from 'next/dynamic';

const ProfileSection = dynamic(() =>
	import('@/features/profile/profile-section').then(mod => mod.ProfileSection)
);
export const SideBarUserInfo = () => {
	const { user } = useAccountInfo();
	const { refetch } = useAccountBalance();

	const { SiteConfigsData } = useGetSiteConfigs();
	const displayCurrencyName = user?.LicenseeSiteSetting?.DisplayCurrencyName;
	const [isLoading, setIsLoading] = useState(false);
	const [nickName, setNickName] = useState('');
	const isOpened = useObservableState(profilePanelService.onProfilePanel$, false);
	const setIsOpened = (isShow: boolean) => profilePanelService.displayProfilePanel(isShow);

	const isShowBalance = useSiteStore(state => state.isShowBalance);

	useEffect(() => {
		if (user?.Niname) {
			setNickName(user?.Niname);
		}
	}, [user]);

	const handleOpen = () => {

		if (!localStorage.getItem('nickname-tip')) {
			localStorage.setItem('nickname-tip', 'true');
		}
		setIsOpened(!isOpened);
		uiService.controlSidebar(false);
	};

	const handleUpdateBalance = () => {
		setIsLoading(true);
		refetch();
		setTimeout(() => {
			setIsLoading(false);
		}, 1000);
	}

	return (

		<div className="sidebar-user">
			<div className="sidebar-user__avatar"></div>
			<div className="sidebar-user__info">
				<div className="sidebar-user__name">
					{user?.DisplayUserName}
				</div>

				{isShowBalance && (
					<div className="sidebar-user__balance">
						<span className="currency">
							{SiteConfigsData?.EnableCurrencyDisplay ? displayCurrencyName : ''}
						</span>
						<span className="balance">{user?.BCredit}</span>
						<div 
							className="icon--refresh"
							onClick={handleUpdateBalance}
							data-loading={isLoading}
						>
							<Icon name="refresh" />
						</div>
					</div>
				)}
			</div>
			<div className="sidebar-user__setting" 
				onClick={handleOpen}
			>
				<Icon name="gear-setting" />
				{
					!nickName && !localStorage.getItem('nickname-tip') &&
					<div className="badge badge--point"></div>
				}
			</div>
			<ProfileSection />
		</div>
	)
}